import type { ErrorResponse } from "react-router"
import { parseRouteErrorBody } from "./errors/boundary-helper"

const genericMessage = "We messed up and something went wrong 😬"

export function getGenericErrorMessages({ error }: { error: unknown }) {
  const func = "getGenericErrorMessages"
  console.log("💥", { func, error })

  const userErrorMessage = genericMessage
  const technicalErrorMessage = error instanceof Error ? error.message : String(error)

  return { userErrorMessage, technicalErrorMessage }
}

export function getRouteErrorMessages({
  error,
  apiCodeToMessage,
}: {
  error: ErrorResponse
  apiCodeToMessage: Record<string, string>
}) {
  const func = "getRouteErrorMessages"
  console.log("💥", { func, error, apiCodeToMessage })

  // Responses thrown by `throwAsRouteError` carry `me.serialize(error)` — a JSON
  // string of the `me.TCombined` union. React Router exposes the body on
  // `error.data` (still a string when the response has no JSON content type),
  // so parse it back into the typed union instead of dereferencing blindly.
  const clientError = parseRouteErrorBody(error.data)

  if (clientError === null) {
    // Not a maul client error — e.g. a response thrown directly by a loader/action.
    const technicalErrorMessage = typeof error.data === "string" ? error.data : ""
    return { userErrorMessage: genericMessage, technicalErrorMessage }
  }

  if (clientError.type === "api") {
    const userErrorMessage = apiCodeToMessage[clientError.code] ?? genericMessage
    const messageSuffix =
      clientError.message !== undefined ? `\nMessage: ${clientError.message}` : ""
    const technicalErrorMessage = `Backend error code: ${clientError.code}
HTTP status: ${clientError.status}${messageSuffix}`

    return { userErrorMessage, technicalErrorMessage }
  }

  const technicalErrorMessage = `Error type: ${clientError.type}
Message: ${clientError.message}`

  return { userErrorMessage: genericMessage, technicalErrorMessage }
}
